import React from 'react';

interface SearchIconProps {
    color?: string;
}

const SearchIcon = ({color = '#0063FF'}: SearchIconProps) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle style={{transition: 'all 0.25s'}} cx="12" cy="11.5" r="5.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path style={{transition: 'all 0.25s'}} d="M16.5 16L19 18.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default SearchIcon;
